import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取客户数据列表（#74） */
export function getCustomerList(data) {
  return request("".concat(BASE_URL) + "/customer/list", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/* 更新客户状态接口 */
export function updateCustomerStatus(data) {
  return request("".concat(BASE_URL) + "/customer/status", METHOD.PUT, data);
}
/* 拉黑指定客户（#21） */
export function updateCustomerblock(data) {
  return request("".concat(BASE_URL) + "/customer/block", METHOD.PUT, data);
}

/* 获取注册来源数据（#75） */
export function getChannelList() {
  return request("".concat(BASE_URL) + "/partner/list", METHOD.GET);
}
/* 获取客户基本信息数据（#78） */
export function getCustomerDetail(id) {
  return request("".concat(BASE_URL) + "/customer/info/" + id, METHOD.GET);
}

/* 获取客户基本信息数据（#79） */
export function updataCustomerDetail(data) {
  return request("".concat(BASE_URL) + "/customer/info", METHOD.PUT, data);
}

/* 获取客户地址数据列表（#80） */
export function getCustomerAdressList(data) {
  return request("".concat(BASE_URL) + "/customer/address/list", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/* 获取客户的当前积分（#46） */
export function getCustomerIntegral(id) {
  return request("".concat(BASE_URL) + "/customer/point/" + id, METHOD.GET);
}

/* 查询客户积分信息记录（#85） */
export function getIntegralList(data) {
  return request("".concat(BASE_URL) + "/customer/integral", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/* 获取客户优惠券数据列表（#87） */
export function getCustomerCouponList(data) {
  return request("".concat(BASE_URL) + "/customer/coupon/list", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}

/* 赠送客户积分（#86） */
export function addCustomerPoint(data) {
  return request("".concat(BASE_URL) + "/customer/givePoint", METHOD.PUT, data);
}
export function getTokenForLogin(data) {
  return request("".concat(BASE_URL) + "/customer/getTokenForLogin", METHOD.GET, data);
}

// /*新增品牌信息数据（#186） */
// export function addBrand(data){
//   return request(`${BASE_URL}` + "/brand", METHOD.POST,data)
// }

// /* 更新品牌信息数据（#182） */
// export function updateBrandInfo(data){
//   return request(`${BASE_URL}` + "/brand", METHOD.PUT,data)
// }

// /* 更新品牌状态信息数据（#183） */
// export function updateBrandStatus(data){
//   return request(`${BASE_URL}` + "/brand/status", METHOD.PUT,data)
// }
// /* 删除品牌信息数据（#184） */
// export function deleteBrand(id){
//   return request(`${BASE_URL}` + "/brand/" + id, METHOD.DELETE)
// }
/* 修改账户状态接口 */
export function changeErpCustomerStatus(data) {
  return request("".concat(BASE_URL) + "/customer/changeStatus", METHOD.PUT, data);
}

/* 删除得意先） */
export function deleteErpCustomer(id, type) {
  return request("".concat(BASE_URL) + "/erp/customer/" + id + '?type=' + type, METHOD.DELETE);
}

/* 修改账号（#10026） */
export function updateCustomerinfo(data) {
  return request("".concat(BASE_URL) + "/customer/changAccount", METHOD.PUT, data);
}

/* 获取账号得意先详情（#10034） */
export function getAccountDetail(data) {
  return request("".concat(BASE_URL) + "/erp/customer/detailById", METHOD.GET, data);
}

/* 获取客户地址数据（#80） */
export function getAddressDetail(data) {
  return request("".concat(BASE_URL) + "/customer/address/list", METHOD.GET, data);
}

/*下载导入模板-#10036 */
export function downloadImportTemp(params) {
  return request("".concat(BASE_URL) + "/erp/customer/downloadmodel", METHOD.GET, params, {
    responseType: 'blob'
  });
}

// 同步得意先信息
export function syncDyxContent() {
  return request("".concat(BASE_URL) + "/systemSetting/syncErpCustomers", METHOD.GET);
}

// 邀请得意先发送邮件
export function inviteErpSendEmail(data) {
  return request("".concat(BASE_URL) + "/erp/customer/sendInviteEmail", METHOD.POST, data);
}

/* 获取得意先导入批次*/
export function getImportTimes() {
  return request("".concat(BASE_URL) + "/erp/customer/importversionlist", METHOD.GET);
}

/* 根据得意先查询出账号列表*/
export function getaccountByerp(id) {
  return request("".concat(BASE_URL) + "/erp/customer/".concat(id, "/accountlist"), METHOD.GET);
}

/**
 * 新增账号
 *   POST erp/customer/addAccount
 *   接口ID：244782510
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-244782510?branchId=5300809
 * @param data
 * @return {Promise<AxiosResponse<T>>}
 */
export function newErpAccount(data) {
  return request("".concat(BASE_URL) + "/erp/customer/addAccount", METHOD.POST, data);
}

/**
 * 新增一个或多个邀请码（#10102）
 *   POST /erp/customer/invitecodes
 *   接口ID：252560970
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-252560970?branchId=5406171
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newInvite(data) {
  return request("".concat(BASE_URL) + "/erp/customer/invitecodes", METHOD.POST, data);
}

/**
 * 得意先邀请码管理列表（#10101）
 *   GET /erp/customer/invitecodes
 *   接口ID：251671161
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-251671161?branchId=5406171
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getInviteList(data) {
  return request("".concat(BASE_URL) + "/erp/customer/invitecodes", METHOD.GET, data);
}
/**
 * 编辑单个邀请码的客户备注（#10104） 
  PUT /erp/customer/invitecodes/remark
  接口ID：252567692
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-252567692?branchId=5406171
 * @param {*} data 
 * @returns 
 */
export function editInviteRemark(data) {
  return request("".concat(BASE_URL) + "/erp/customer/invitecodes/remark", METHOD.PUT, data);
}
/**
 * 删除单个邀请码（#10103）  
  DELETE /erp/customer/invitecodes
  接口ID：252566785
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-252566785?branchId=5406171
 * @param {*} data
 * @returns 
 */
export function deleteInvite(id) {
  return request("".concat(BASE_URL) + "/erp/customer/invitecodes/".concat(id), METHOD.DELETE);
}

/**
 * 删除地址
 *   DELETE /customer/address/{id}
 *   接口ID：277637871
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-277637871
 * @param id
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteAddress(id) {
  return request("".concat(BASE_URL) + "/customer/address/".concat(id), METHOD.DELETE);
}
export default {
  getCustomerList: getCustomerList,
  updateCustomerStatus: updateCustomerStatus,
  updateCustomerblock: updateCustomerblock,
  getChannelList: getChannelList,
  getCustomerDetail: getCustomerDetail,
  getCustomerAdressList: getCustomerAdressList,
  getCustomerIntegral: getCustomerIntegral,
  getIntegralList: getIntegralList,
  getCustomerCouponList: getCustomerCouponList,
  getTokenForLogin: getTokenForLogin,
  changeErpCustomerStatus: changeErpCustomerStatus,
  deleteErpCustomer: deleteErpCustomer,
  updateCustomerinfo: updateCustomerinfo,
  getAddressDetail: getAddressDetail,
  getAccountDetail: getAccountDetail,
  syncDyxContent: syncDyxContent,
  inviteErpSendEmail: inviteErpSendEmail
};